// Full-sensor still capture (ImageCapture API) + continuous autofocus.

export async function enableContinuousFocus(track) {
  try {
    const caps = track?.getCapabilities?.() || {};
    const adv = {};
    if (caps.focusMode?.includes("continuous")) adv.focusMode = "continuous";
    if (caps.exposureMode?.includes("continuous")) adv.exposureMode = "continuous";
    if (caps.whiteBalanceMode?.includes("continuous")) adv.whiteBalanceMode = "continuous";
    if (Object.keys(adv).length) await track.applyConstraints({ advanced: [adv] });
  } catch (e) {
    console.warn("continuous focus not applied:", e);
  }
}

// Returns an ImageBitmap at full photo resolution, or null to fall back to the video frame.
export async function takeFullResPhoto(track, vw, vh) {
  if (!track || typeof window.ImageCapture !== "function") return null;
  try {
    const ic = new window.ImageCapture(track);
    const settings = {};
    try {
      const pc = await ic.getPhotoCapabilities();
      if (pc?.imageWidth?.max) settings.imageWidth = pc.imageWidth.max;
      if (pc?.imageHeight?.max) settings.imageHeight = pc.imageHeight.max;
    } catch (_) {}
    const blob = await ic.takePhoto(settings);
    const bmp = await createImageBitmap(blob);
    const sameOrientation = bmp.width > bmp.height === vw > vh;
    if (!sameOrientation || bmp.width * bmp.height <= vw * vh) {
      bmp.close?.();
      return null;
    }
    return bmp;
  } catch (e) {
    console.warn("takePhoto failed, using video frame:", e);
    return null;
  }
}
